/*
This file is located in the main branch
Last time the file was updated (UTC): [11.12.2024 08:50:34]
Permissions to update outside the main branch: [false]
*/

import { requiredRule, ValidatedDynamicList, ValidatedInput } from '@finbeat/react-toolkit';
import { QuestionaryInfo, QuestionaryTradeOrg } from 'models/api/questionary';
import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import {
    QuestionariesTradeOrgsForm,
    QuestionariesTradeOrgsFormWrapper,
} from './QuestionariesTradeOrgsForm';
import './QuestionaryModal.scss';

const QuestionaryModalMain = ({ innerRef }: { innerRef?: RefObject<HTMLElement> }) => {
    const { t } = useTranslation();

    return (
        <>
            <ValidatedInput
                name="name"
                label={t('BackOfficeName')}
                rules={{ required: requiredRule }}
            />
            <ValidatedDynamicList<QuestionaryInfo, QuestionaryTradeOrg>
                formComponent={(props) => <QuestionariesTradeOrgsForm {...props} />}
                wrapper={(props) => <QuestionariesTradeOrgsFormWrapper {...props} />}
                emptyRecord={{
                    id: 0,
                    tradeOrgId: null,
                    outletId: null,
                }}
                innerRef={innerRef}
                name="tradeOrgs"
                compareFunc={(a, b) => a?.tradeOrgId === b?.tradeOrgId}
            />
            <ValidatedInput name="dsc" type="textarea" label={t('BackOfficeDescription')} />
        </>
    );
};

export default QuestionaryModalMain;
